// SurveySubmitError: typed error for the survey submit pipeline.
// Codes: VALIDATION_FAILED, PAYMENT_REQUIRED (re-exported from store/auth-status),
// SURVEY_NOT_EDITABLE, SURVEY_PERSIST_FAILED,
// QUESTION_PERSIST_FAILED (see `failures` for per-question detail).
// PAYMENT_REQUIRED is re-exported from its canonical home so callers can import
// all codes from this one module.

import { ApiError } from "./api-error";
import { PAYMENT_REQUIRED } from "store/auth-status";

export const VALIDATION_FAILED = "VALIDATION_FAILED";
export const SURVEY_NOT_EDITABLE = "SURVEY_NOT_EDITABLE";
export const SURVEY_PERSIST_FAILED = "SURVEY_PERSIST_FAILED";
export const QUESTION_PERSIST_FAILED = "QUESTION_PERSIST_FAILED";

// Friendly copy for the SURVEY_NOT_EDITABLE backend code. Covers both the
// date-modification variant ("state X does not permit modifying Y to Z") and
// the non-date-field variant ("state X is not editable") without misleading
// the user about either. Surfaced verbatim by build.js without the generic
// "Failed to save survey:" prefix.
export const SURVEY_NOT_EDITABLE_MESSAGE =
    "This survey can't be saved in its current state. " +
    "Please review the survey dates and status, then try again.";

export { PAYMENT_REQUIRED };

export class SurveySubmitError extends ApiError {
    constructor(message, code, options = {}) {
        super({ message, code });
        this.name = "SurveySubmitError";
        // ApiError sets `code` from the options object; re-assign to make
        // the constructor argument the source of truth and to keep the
        // field non-nullable even when callers pass `code: null`.
        this.code = code;
        this.failures = options.failures;
        // Pass-through for caller-specific flags. Used by validate() to
        // mark the use_comprehend-only minimal-payload path
        // (useComprehendOnly: true). Keep this generic rather than adding
        // a new parameter per case so the constructor signature stays small.
        this.useComprehendOnly = Boolean(options.useComprehendOnly);
    }
}
